import { defineMessages } from 'react-intl';

export default defineMessages({
  adminPanel: {
    id: 'Unknown.AdminPanel.title',
    defaultMessage: 'Admin Panel'
  },
  options: {
    id: 'Unknown.AdminPanel.options',
    defaultMessage: 'Options'
  },
  reports: {
    id: 'Unknown.AdminPanel.reports',
    defaultMessage: 'Reports'
  },
  partners: {
    id: 'Unknown.AdminPanel.partners',
    defaultMessage: 'Partners'
  },
  realtors: {
    id: 'Unknown.AdminPanel.realtors',
    defaultMessage: 'Realtors'
  }
});
